
import React from "react";

interface VoterReachOutCampaignOverviewProps {
  data?: {
    name?: string;
    msg?: { ds?: { text?: string } };
    vrot?: { name?: string };
    tgt?: { name?: string };
    status?: string;
  };
}

const VoterReachOutCampaignOverview = ({
  data,
}: VoterReachOutCampaignOverviewProps) => {
  const status = String(data?.status || "Unknown");
  const normalizedStatus = status.toLowerCase();

  const statusStyle =
    normalizedStatus === "finished"
      ? "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
      : normalizedStatus === "failed"
        ? "bg-rose-50 text-rose-700 ring-rose-600/20"
        : normalizedStatus === "queued"
          ? "bg-amber-50 text-amber-700 ring-amber-600/20"
          : normalizedStatus === "campaign-manager-review"
            ? "bg-blue-50 text-blue-700 ring-blue-600/20"
            : "bg-slate-100 text-slate-600 ring-slate-500/20";

  const details = [
    {
      label: "Message",
      value: data?.msg?.ds?.text || "No message available",
    },
    {
      label: "Target group",
      value: data?.vrot?.name || data?.tgt?.name || "No target selected",
    },
  ];

  return (
    <div className="space-y-5 pb-3">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
        <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-xl text-indigo-600">
          ✦
        </div>

        <p className="text-xs font-bold uppercase tracking-wider text-slate-400">
          Campaign name
        </p>
        <h2 className="mt-2 break-words text-xl font-bold leading-7 text-slate-900">
          {data?.name || "Untitled campaign"}
        </h2>

        <div className="mt-5 border-t border-slate-100 pt-4">
          <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">
            Current status
          </p>
          <span
            className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold ring-1 ring-inset ${statusStyle}`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-current" />
            {normalizedStatus === "campaign-manager-review"
              ? "Under Review"
              : status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </div>
      </div>

      {details.map((item) => (
        <div
          key={item.label}
          className="rounded-2xl border border-slate-200 bg-white p-5"
        >
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400">
            {item.label}
          </p>
          <p className="mt-3 whitespace-pre-wrap break-words text-sm leading-6 text-slate-700">
            {item.value}
          </p>
        </div>
      ))}

      <div className="rounded-xl border border-indigo-100 bg-indigo-50/60 p-4">
        <p className="text-sm leading-5 text-slate-600">
          Campaign details are shown using the information currently available
          for this campaign.
        </p>
      </div>
    </div>
  );
};

export default VoterReachOutCampaignOverview;
